import { useState } from "react";
import { useHistory } from "react-router-dom";

import { ShowWarningToast } from 'shared/functions';
import * as helper from "./helper";

const ModelCreateTile = () => {
    const [SKU, setSKU] = useState("");

    const history = useHistory();

    const handleChange = (event) => {
        setSKU(event.target.value);
    }
    const handleSubmit = async () => {
        const newSKU = await helper.existingSKU(SKU);
        if (newSKU) {
            const url = `/overstock/${SKU}/create`
            history.push(url);
        } else {
            ShowWarningToast(`This model already exists, you don't need to create it again.`);
        }
    }

    return (
        <article className="tile is-child notification">
            <p className="title">New Model</p>
            <p className="subtitle">Create a new model here</p>
            <div className="field has-addons">
                <div className="control is-expanded">
                    <input
                        className="input"
                        onChange={handleChange}
                        placeholder="Enter the SKU of the model here"
                        value={SKU}
                        id="model-create"
                    ></input>
                </div>
                <div className="control">
                    <button className="button is-primary" onClick={handleSubmit}>Create</button>
                </div>
            </div>
        </article>
    );
}

export { ModelCreateTile };
